import * as Joi from "joi";

export const RegistrationSchema = Joi.object({
    name: Joi.string().min(3).max(30).required('Please provide your name'),
    email: Joi.string()
        .email({ tlds: { allow: false } })
        .required('Please provide your email'),
    password: Joi.string().min(8).required('Please provide a password'),
}).options({ abortEarly: false });
